import React from 'react';

const InputColor = (props) => 
    <input type="text" name="nameColor" onChange={props.handleChangeName} />;

export default InputColor;


// WEBPACK FOOTER //
// ./src/components/InputColor/InputColor.js